import { v4 as uuidv4 } from 'uuid'
import { submitVisitEvent } from '@/api'

function getUV() {
  const key = 'uv_id'
  const today = new Date().toISOString().slice(0, 10) // YYYY-MM-DD
  const stored = localStorage.getItem(key)
  if (stored) {
    const { uuid, date } = JSON.parse(stored)
    // if (date === today) return uuid // 无需按天重新生成 uuid
    return uuid
  }

  const uuid = uuidv4()
  localStorage.setItem(key, JSON.stringify({ uuid, date: today }))
  return uuid
}

export async function reportEvent(path: string, pathName: string) {
  const payload = {
    path,
    pathName,
    uvkey: getUV(),
  }

  try {
    await submitVisitEvent(payload)
  } catch (err) {
    console.error(`[track] 上报失败`, err)
  }
}
